var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ApplyHereList',{attrs:{"title":"Apply Here","collection":"apply-here","items":_vm.applyHereList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }